import { provideEnvironmentInitializer, inject, effect } from "@angular/core";
import { toSignal } from "@angular/core/rxjs-interop";
import { Route } from "@angular/router";
import {
  ApplicationSource,
  EnvironmentEnum,
  HostContextStore,
} from "@kehe/phoenix-host-utils";
import { environment } from "../../environments/environment";
import { ModalService } from "@kehe/phoenix-utils";
import { Store } from "@ngrx/store";
import {
  selectUserActions,
  selectUserEmail,
  selectUserFirstName,
  selectUserLastName,
} from "@app/shared/state/authentication/authentication.selectors";
import { AuthGuardService } from "@app/authentication/auth-guard.service";
import { Constants } from "@app/constants/constants";
import { KeheNavigationItem } from "@kehe/phoenix-top-navigation-panel";
import { discoProductsGuard } from "./discontinued-products.guard";

const urlPath = "discontinued-products";

export const discoProductsNavItem = new KeheNavigationItem(
  `${Constants.SubMenu.DiscontinuedProducts}`,
  `/${urlPath}`,
  { exact: false },
  undefined,
  undefined,
  undefined,
  urlPath,
);

export const discoProductsRoute: Route = {
  path: urlPath,
  providers: [
    HostContextStore,
    ModalService,
    provideEnvironmentInitializer(() => {
      const globalStore = inject(Store);
      const hostContextStore = inject(HostContextStore);
      const userEmail = toSignal(globalStore.select(selectUserEmail));
      const userFirstName = toSignal(globalStore.select(selectUserFirstName));
      const userLastName = toSignal(globalStore.select(selectUserLastName));
      const userActions = toSignal(globalStore.select(selectUserActions));

      effect(
        () => {
          hostContextStore.set({
            environment: environment.current as unknown as EnvironmentEnum,
            apiBaseUrl: environment.api,
            userEmail: userEmail(),
            userFirstName: userFirstName(),
            userLastName: userLastName(),
            userActions: userActions(),
            userGroupIds: null,
            applicationSource: ApplicationSource.Supplier,
            web: location.origin,
            v1ConnectHost: null,
          });
        },
        { allowSignalWrites: true },
      );
    }),
  ],
  loadChildren: () =>
    import("@kehe/discontinued-products-lib").then((m) => m.libRoutes),
  canActivate: [AuthGuardService, discoProductsGuard],
};
